import React, { Component } from 'react';
import ReactDatamap from './reactDatamaps';
import * as styles from './index.css';

class Datamap extends Component {
  constructor() {
    super();
    this.state = {};
  }

  render() {
    return (
      <div className={styles.dataMap}>
        <ReactDatamap />
      </div>
    );
  }
}

Datamap.propTypes = {
  datamap: React.PropTypes.object,
};

export default Datamap;



// WEBPACK FOOTER //
// ./app/components/datamap/index.js